// Dashboard layout-specific JavaScript
// This replaces app/assets/javascripts/dashboard.js

import { ready } from "../modules/core";

// Export a function that initializes the dashboard layout
export function initialize() {
  // Initialize Select2 dropdowns
  initializeSelect2();

  // Initialize Charts if any exist
  initializeCharts();

  // Add event listeners for sidebar toggling
  document.querySelectorAll('#sidebarToggle').forEach(toggle => {
    toggle.addEventListener('click', function() {
      const sidebar = document.getElementById('adminSidebar');
      const content = document.getElementById('content-wrapper');

      if (sidebar) {
        sidebar.classList.toggle('tw-admin-sidebar-collapsed');
      }

      if (content) {
        content.classList.toggle('tw-admin-content-with-collapsed-sidebar');
      }

      // Toggle the icon direction
      const icon = this.querySelector('i');
      if (icon) {
        icon.classList.toggle('fa-angle-left');
        icon.classList.toggle('fa-angle-right');
      }
    });
  });

  // Initialize dashboard-specific components
  initializeDashboardComponents();

  return true;
}

// Initialize enhanced select elements - using Stimulus controller instead of Select2
function initializeSelect2() {
  // Find any legacy select2 elements that don't have a controller
  document.querySelectorAll('select.select2:not([data-controller*="select"])').forEach(select => {
    // Add the Stimulus controller to handle enhanced select functionality
    select.setAttribute('data-controller', 'select');
    select.setAttribute('data-select-placeholder-value', select.getAttribute('placeholder') || 'Select an option...');
  });
}

// Initialize Chart.js charts if they exist
function initializeCharts() {
  // Only run if Chart.js is available (loaded via CDN or other means)
  if (window.Chart) {
    // Find all canvas elements that should have charts
    document.querySelectorAll('canvas[data-chart-type]').forEach(canvas => {
      try {
        const chartType = canvas.getAttribute('data-chart-type');
        const chartData = JSON.parse(canvas.getAttribute('data-chart-data') || '{}');
        const chartOptions = JSON.parse(canvas.getAttribute('data-chart-options') || '{}');
        
        if (chartType && chartData) {
          new window.Chart(canvas, {
            type: chartType,
            data: chartData,
            options: chartOptions
          });
        }
      } catch (error) {
        console.error('Error initializing chart:', error);
      }
    });
  }
}

// Initialize dashboard-specific UI components
function initializeDashboardComponents() {
  // Apply background images from data attributes
  document.querySelectorAll('[data-bg-image]').forEach(element => {
    const bgImage = element.getAttribute('data-bg-image');
    if (bgImage) {
      element.style.backgroundImage = `url(${bgImage})`;
    }
  });
  
  // Handle collapsible sections
  document.querySelectorAll('[data-toggle="collapse"]').forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('data-target'));
      if (target) {
        target.classList.toggle('show');
      }
    });
  });
  
  // Handle dashboard tabs with native JavaScript (no jQuery dependency)
  // Always use our native implementation for consistency
  document.querySelectorAll('[data-toggle="tab"]').forEach(tabLink => {
    tabLink.addEventListener('click', function(e) {
      e.preventDefault();

      try {
        // Remove active class from all tab links
        document.querySelectorAll('[data-toggle="tab"]').forEach(link => {
          link.classList.remove('active');
        });

        // Add active class to clicked tab link
        this.classList.add('active');

        // Get the target safely
        const href = this.getAttribute('href');
        if (!href) return;

        // Hide all tab panes
        const tabContent = this.closest('.tab-content') || document.querySelector('.tab-content');
        if (tabContent) {
          tabContent.querySelectorAll('.tab-pane').forEach(pane => {
            pane.classList.remove('active');
            pane.classList.remove('show');
          });

          // Show the target tab pane
          const target = document.querySelector(href);
          if (target) {
            target.classList.add('active');
            target.classList.add('show');
          }
        }
      } catch (error) {
        // Silently handle error - no console output
      }
    });
  });
}

// Also initialize on page load using the ready function
ready(() => {
  // We don't need jQuery anymore as we're using native browser APIs and Stimulus
  initialize();
});

// Export the module name for easier debugging
export const MODULE_NAME = 'dashboard';

// Default export for dynamic imports
export default {
  initialize,
  MODULE_NAME
};